import React from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { formatISO } from 'date-fns';

import PropTypes from 'prop-types';
import AbEnvironment from '../auth/AbEnvironment';

import withStyles from '@mui/styles/withStyles';
import { Button,  Checkbox, FormControlLabel, Grid, TextField, Typography, InputLabel } from '@mui/material';
import AppBindStyles from '../../AppBindStyles';


import LoadingSpinner from '../ui/LoadingSpinner';
import SavingSpinner from '../ui/SavingSpinner';
import ServerError from '../ui/ServerError';
import Address from '../ui/Address'

import AccountConfirmUpdateMutation from '../account/AccountConfirmUpdateMutation';
import UserConfirmUpdateMutation from '../account/UserConfirmUpdateMutation';

const abEnvironment = new AbEnvironment();
const CustomerAddressAssentStepQuery = graphql`
query CustomerAddressAssentStepQuery($accountId: UUID!) {
  accountTByAccountId(accountId: $accountId) {
    accountId
    accountNum
    accountName
    contactLastName
    contactFirstName
    contactEmail
    contactPhone
    address1
    address2
    city
    state
    country
    postalCode
  }
}
`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
  },
  accountLogo: {
    float: 'left',
    marginRight: 15
  },
  button: {
    width: 52,
  },
  input: {
    display: 'none',
  }
});

class CustomerAddressAssentStep extends React.Component {
  
  state = {
    firstName:  null,
    lastName:   null,
    country:    null,
    state:      null,
    city:       null,
    postalCode: null,
    address1:   null,
    address2:   null,
    showSpinner: false,

    accepted:    false,

    forceFetch: 1
  }

  isContactComplete(queryProps) {

    if (this.getValueForRender(this.state.contactFirstName,   queryProps.accountTByAccountId.contactFirstName, '') === '') {
      return false;
    }
    if (this.getValueForRender(this.state.contactLastName,   queryProps.accountTByAccountId.contactLastName, '') === '') {
      return false;
    }

    if (!this.state.accepted) {
      return false;
    }

    return true;
  }


  isAddressComplete(queryProps) {

    if (this.getValueForRender(this.state.address1,   queryProps.accountTByAccountId.address1, '') === '') {
      return false;
    }
    if (this.getValueForRender(this.state.city,   queryProps.accountTByAccountId.city, '') === '') {
      return false;
    }
    if (this.getValueForRender(this.state.state,   queryProps.accountTByAccountId.state, '') === '') {
      return false;
    }
    if (this.getValueForRender(this.state.postalCode,   queryProps.accountTByAccountId.postalCode, '') === '') {
      return false;
    }
    if (this.getValueForRender(this.state.country,   queryProps.accountTByAccountId.country, '') === '') {
      return false;
    }

    return true;
  }

  
  isInformationComplete(queryProps) {

    if (this.isAddressComplete(queryProps) && this.isContactComplete(queryProps)) {
      return true;
    } else {
      return false;
    }
  }

  isBackDisabled() {
    if (this.props.activeStep === 0)
      return true;

    return false;
  }

  isNextDisabled(queryProps) {

    if (this.props.activeStep === this.props.assignedStep) {
      if (!this.isInformationComplete(queryProps)) {
        return true;
      } 
    }
    return false;
  }

  setCountry    = (country)    => { this.setState({country:    country}); }  
  setRegion     = (region)     => { this.setState({state:      region}); }  
  setCity       = (city)       => { this.setState({city:       city}); }  
  setPostalCode = (postalCode) => { this.setState({postalCode: postalCode}); }  
  setAddress1   = (address1)   => { this.setState({address1:   address1}); }  
  setAddress2   = (address2)   => { this.setState({address2:   address2}); }  

  getValueForRender(state_member, prop_member, theDefault)
  {
    if (state_member != null)
      return state_member;

    if (prop_member != null)
      return prop_member;

    return theDefault;
  }


  showSpinner() {
    return this.state.showSpinner;
  }


  render() {
    const { logError } = this.props.auth;

    const classes = this.props.classes;

    let displayOnly = false;
    if (this.props.activeStep > this.props.assignedStep) {
      displayOnly = true;
    }

    let skipAllowed = false;
   
    let acctId = abEnvironment.getUserAttribute("a_id");

    return (
      <QueryRenderer
        environment={abEnvironment.getEnvironment()}
        query={CustomerAddressAssentStepQuery}
        variables={{accountId: acctId, forceFetch: this.state.forceFetch}}
        render={({error, props})=> {
          if (error) {
            logError(error.message);
            return (
              <ServerError/>
            );
          } else if (props) {

            let address = {
              country:    this.getValueForRender(this.state.country,    props.accountTByAccountId.country,    ''),
              state:      this.getValueForRender(this.state.state,      props.accountTByAccountId.state,      ''),
              city:       this.getValueForRender(this.state.city,       props.accountTByAccountId.city,       ''),
              postalCode: this.getValueForRender(this.state.postalCode, props.accountTByAccountId.postalCode, ''),
              address1:   this.getValueForRender(this.state.address1,   props.accountTByAccountId.address1,   ''),
              address2:   this.getValueForRender(this.state.address2,   props.accountTByAccountId.address2,   '')
            };

  
            if (!displayOnly) {
              return (
        
                <Grid container spacing={2}  style={{marginTop: 8}}>
          
                  <Grid item xs={12}>
                    <Grid container spacing={1} direction="row" justifyContent="flex-start">
                      <Grid item>
                        <Typography variant="body1">
                        {'What is the name and business address ' + this.props.account.accountTByParentId.accountName + ' will use to subscribe on your behalf?'}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                      <TextField  data-recording-ignore="mask"
                        id="firstName" label={'First name *'} 
                        value={this.getValueForRender(this.state.firstName,    props.accountTByAccountId.contactFirstName,    '')}
                        onChange={ (e) => this.setState({firstName: e.target.value}) }
                        inputProps={{ maxLength: 32 }}
                      />

                  </Grid>
                  <Grid item xs={12} sm={6}>
                      <TextField  data-recording-ignore="mask"
                        id="lastName" label={'Last name *'} 
                        value={this.getValueForRender(this.state.lastName,    props.accountTByAccountId.contactLastName,    '')}
                        onChange={ (e) => this.setState({lastName: e.target.value}) }
                        inputProps={{ maxLength: 32 }}
                      />

                  </Grid>
                   <Grid item xs={12} style={{marginBottom: 16}}>
                    <Address
                      showRequired={false}
                      address={address}
                      regionLabel={"Region"}
                      setCountryCodeState={this.setCountry}
                      setRegionCodeState={this.setRegion}
                      setCityState={this.setCity}
                      setPostalCodeState={this.setPostalCode}
                      setAddress1State={this.setAddress1}
                      setAddress2State={this.setAddress2}
                    />
                  </Grid>
                  <Grid item xs={12} className={classes.descriptiveText}>
                    <FormControlLabel
                      control={<Checkbox
                        checked={this.state.accepted}
                        value="accepted"
                        onChange={ (e) => this.setState({ accepted: e.target.checked }) }
                      />}
                      label={
                        <div>
                          <span>I accept the </span>
                          <a target="_blank" rel="noopener noreferrer" href="http://www.appbind.com/terms">AppBind Terms of Service</a>
                          <span> and </span>
                          <a target="_blank" rel="noopener noreferrer" href="http://www.appbind.com/privacy">Privacy Policy</a>
                        </div>}
                    />
                  </Grid>
                  {this.props.activeStep === this.props.assignedStep &&
                  <Grid item xs={12}>
                    <Button
                      disabled={this.isBackDisabled()}
                      color="primary" variant="outlined"
                      onClick={() => this.props.handleBack()}
                      style={AppBindStyles.bottomButton}>
                      Back
                    </Button>

                    {!this.showSpinner() &&        
                    <Button
                      color="primary" variant="contained"
                      disabled={this.isNextDisabled(props)}
                      onClick={() => { this.updateUserAndAccount();}}
                      style={AppBindStyles.bottomButton}>
                        Next
                    </Button>
                    }
                    {this.showSpinner() &&
                    <Button color="primary" 
                            variant="contained"
                            style={AppBindStyles.bottomButton}>
                        <SavingSpinner/>
                    </Button>
                    }

                    {skipAllowed &&
                      <Button
                        color="primary" variant="outlined"
                        onClick={() => { this.props.handleNext();}}
                        style={AppBindStyles.bottomButton}>
                        Skip
                      </Button>
                    }
                  </Grid>
                      
                  } 
                </Grid>       
              );
          
            } else {

              //display only
              return (
        
                <Grid container style={{marginTop: 8}}>
                  <React.Fragment>
                    <Grid item xs={12}>
                      <InputLabel shrink style={{marginBottom:6}}>Business address</InputLabel>
                      <Typography variant="body2">
                        <strong>{this.getValueForRender(this.state.contactFirstName, props.accountTByAccountId.contactFirstName, '')} {this.getValueForRender(this.state.contactLastName, props.accountTByAccountId.contactLastName, '')}</strong><br/>
                        {address.address1} {address.address2}<br/>
                        {address.city}, {address.state}, {address.country} {address.postalCode}  
                      </Typography>
                    </Grid>
                  </React.Fragment>
                </Grid>                  
              );
        
            }
          }
          if (!displayOnly) {
            return <div><LoadingSpinner/></div>
          }
        }
      }
      />
    );

  }

  updateUserAndAccount() {


    let userId = abEnvironment.getUserAttribute('u_id');
    let accountId = abEnvironment.getUserAttribute('a_id');
    let nowdate = formatISO(new Date());

    const { logError } = this.props.auth;
    const { accountName, lastName, firstName, address1, address2, city, state, country, postalCode } = this.state;

    let aAccountName = null;
    let aConfDate = null;
    let uLastName = null;
    let uFirstName = null;
    let uAddress1 = null;
    let uAddress2 = null;
    let uCity = null;
    let uState = null;
    let uCountry = null;
    let uPostalCode = null;
    let uConfDate = null;
    let uTermsDate = null;

    let setValuesOnAccount = false;

    this.setState({showSpinner: true});    

    Promise.resolve()
    .then(() => {
      // Save account info
      aAccountName = accountName;
      aConfDate = nowdate;

      if ( (abEnvironment.getUserAttribute('a_lastName')   != null && abEnvironment.getUserAttribute('a_lastName') !== '')  ||
            (abEnvironment.getUserAttribute('a_firstName')  != null && abEnvironment.getUserAttribute('a_firstName') !== '') ||
            (abEnvironment.getUserAttribute('a_address1')   != null && abEnvironment.getUserAttribute('a_address1') !== '')  ||
            (abEnvironment.getUserAttribute('a_address2')   != null && abEnvironment.getUserAttribute('a_address2') !== '')  ||
            (abEnvironment.getUserAttribute('a_city')       != null && abEnvironment.getUserAttribute('a_city') !== '')      ||
            (abEnvironment.getUserAttribute('a_state')      != null && abEnvironment.getUserAttribute('a_state') !== '')     ||
            (abEnvironment.getUserAttribute('a_country')    != null && abEnvironment.getUserAttribute('a_country') !== '')   ||
            (abEnvironment.getUserAttribute('a_postalCode') != null && abEnvironment.getUserAttribute('a_postalCode') !== '') )
      {
        setValuesOnAccount = true;
        return AccountConfirmUpdateMutation.commit(accountId, aAccountName, aConfDate,
                                                    lastName, firstName, address1, address2, city, state, country, postalCode);
      }
      else
      {
        return AccountConfirmUpdateMutation.commit(accountId, aAccountName, aConfDate,
                                                    null, null, null, null, null, null, null, null);
      }
      
    })
    .then(() => {
      uLastName = lastName;
      uFirstName = firstName;
      uAddress1 = address1;
      uAddress2 = address2;
      uCity = city;
      uState = state;
      uCountry = country;
      uPostalCode = postalCode;
      uConfDate = nowdate;
      uTermsDate = nowdate;

      if (uConfDate != null || uTermsDate != null) {
        return UserConfirmUpdateMutation.commit(
          userId,
          uLastName, uFirstName, uAddress1, uAddress2, uCity, uState, uCountry, uPostalCode, uConfDate,
          uTermsDate);
      }
      else
      {
        return null;
      }
    })
    /*
    .then((resp) => {
      // Removed Hubspot, ActiveCampaign in process
      let payload = {
        operation: "asyncLinkAccountToActiveCampaign",
        params: {
          accountId: accountId
        }
      };
  
      if (accountType === '3') {
        return callPartnerApi('appbind/generic', 'POST', payload);
      } else {
        return null;
      }  
    
    })
    */
    .then(() => {
      if (aAccountName != null)
        abEnvironment.setUserAttribute('a_accountName', aAccountName);
      if (aConfDate != null)
        abEnvironment.setUserAttribute('a_accountCDate', aConfDate);

      if (setValuesOnAccount) {
        if (lastName != null)
          abEnvironment.setUserAttribute('a_lastName', lastName);
        if (firstName != null)
          abEnvironment.setUserAttribute('a_firstName', firstName);
        if (address1 != null)
          abEnvironment.setUserAttribute('a_address1', address1);
        if (address2 != null)
          abEnvironment.setUserAttribute('a_address2', address2);
        if (city != null)
          abEnvironment.setUserAttribute('a_city', city);
        if (state != null)
          abEnvironment.setUserAttribute('a_state', state);
        if (country != null)
          abEnvironment.setUserAttribute('a_country', country);
        if (postalCode != null)
          abEnvironment.setUserAttribute('a_postalCode', postalCode);
      }

      if (uLastName != null)
        abEnvironment.setUserAttribute('u_lastName', uLastName);
      if (uFirstName != null)
        abEnvironment.setUserAttribute('u_firstName', uFirstName);

      if (uAddress1 != null)
        abEnvironment.setUserAttribute('u_address1', uAddress1);
      if (uAddress2 != null)
        abEnvironment.setUserAttribute('u_address2', uAddress2);
      if (uCity != null)
        abEnvironment.setUserAttribute('u_city', uCity);
      if (uState != null)
        abEnvironment.setUserAttribute('u_state', uState);
      if (uCountry != null)
        abEnvironment.setUserAttribute('u_country', uCountry);
      if (uPostalCode != null)
        abEnvironment.setUserAttribute('u_postalCode', uPostalCode);

      if (uConfDate != null)
        abEnvironment.setUserAttribute('u_userCDate', uConfDate);
      if (uTermsDate != null)
        abEnvironment.setUserAttribute('u_termsDate', uTermsDate);

      this.setState({showSpinner: false});    
      this.props.handleNext();

    })
    .catch(err => {
      logError('Exception in CustomerAddressAssentStep.js: ' + err);

      window.location.reload();
    });
    
  }

}


CustomerAddressAssentStep.propTypes = {
  account: PropTypes.object.isRequired,
  assignedStep: PropTypes.number.isRequired,
  activeStep: PropTypes.number.isRequired,
  handleBack: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired
};

export default withStyles(styleSheet)(CustomerAddressAssentStep);
